import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=62c59a6a"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c59a6a')) {
      api.createRecord('62c59a6a', component.options)
    } else {
      api.reload('62c59a6a', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=62c59a6a", function () {
      api.rerender('62c59a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Dashboard.vue"
export default component.exports